import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { WEB_API_URL } from 'services/constants/env';
import { TUserApi } from './types';

export const user: TUserApi = {
	getOrganizations: () => http.get(endpoint.user.ORGANIZATIONS).then((response) => response.data),
	getUserInfo: () => http.get(endpoint.user.USER_INFO).then((response) => response.data),
	getNewMessageCount: () =>
		http.get(endpoint.user.GET_NEW_MESSAGE_COUNT).then((response) => response.data),
	getMessages: () => http.get(endpoint.user.FETCH_MESSAGES).then((response) => response.data),
	markAsReadMessage: (payload) =>
		http
			.post(endpoint.user.MARK_AS_READ_MESSAGE(payload.messageId))
			.then((response) => response.data),
	deleteMessage: (payload) =>
		http.delete(endpoint.user.DELETE_MESSAGE(payload.messageId)).then((response) => response.data),
	getEmAssignment: () => http.get(endpoint.user.EM_ASSIGNMENT).then((response) => response.data),
	updateSettings: (payload) =>
		http.post(endpoint.user.UPDATE_SETTINGS, payload).then((response) => response.data),
	getContractDocuments: (payload) =>
		http
			.post(endpoint.user.CONTRACT_DOCUMENTS(payload.emId), payload.body)
			.then((response) => response.data),
	downloadContractDocument: (payload) =>
		http
			.get(endpoint.user.CONTRACT_DOCUMENT_DOWNLOAD(payload.emId, payload.attachmentId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	fetchContractDocument: (params) =>
		http.get(endpoint.user.CONTRACT_DOCUMENT_DOWNLOAD(params.emId, params.attachmentId), {
			responseType: 'blob',
		}),
	fetchUsers: () => http.get(endpoint.user.FETCH_USERS).then((response) => response.data),
	updateUser: (payload) =>
		http.post(endpoint.user.UPDATE_USER, payload).then((response) => response.data),
	deleteUser: (payload) =>
		http.delete(endpoint.user.DELETE_USER(payload.userId)).then((response) => response.data),
	createDashboardUser: (payload) =>
		http.post(endpoint.user.CREATE_DASHBOARD_USER, payload).then((response) => response.data),

	updateNotificationSubscription: (payload) =>
		http
			.post(endpoint.user.UPDATE_NOTIFICATION_SUBSCRIPTION, payload.data, {
				params: { email: payload.email },
			})
			.then((response) => response.data),
	fetchNotificationSubscriptions: (payload) =>
		http
			.get(endpoint.user.FETCH_NOTIFICATION_SUBSCRIPTIONS(payload.email))
			.then((response) => response.data),
	resetCredentials: (payload) =>
		http.post(endpoint.user.CREDENTIALS_RESET, payload).then((response) => response.data),
	getHubspotVisitorToken: () =>
		http.get(endpoint.hubspot.VISITOR_TOKEN).then((response) => response.data),
	get2FAStatus: () => http.get(endpoint.user.TWO_FA_STATUS).then((response) => response.data),
	enable2FA: (payload) =>
		http.post(endpoint.user.TWO_FA_ENABLE, payload).then((response) => response.data),
	disable2FA: (payload) =>
		http.post(endpoint.user.TWO_FA_DISABLE, payload).then((response) => response.data),
	getSpecialSchemes: () =>
		http.get(endpoint.user.SPECIAL_SCHEMES).then((response) => response.data),
	getIntegrations: () => http.get(endpoint.user.INTEGRATIONS).then((response) => response.data),
	newWixIntegration: (payload) =>
		http.post(endpoint.user.NEW_WIX_INTEGRATION, payload).then((response) => response.data),
	newSquarespaceIntegration: (payload) =>
		http.post(endpoint.user.NEW_SQUARESPACE_INTEGRATION, payload).then((response) => response.data),
	newStripeIntegration: (payload) =>
		http.post(endpoint.user.NEW_STRIPE_INTEGRATION, payload).then((response) => response.data),
	getHmrcOauthUrl: () =>
		http.get(endpoint.hmrc.GET_HMRC_OAUTH_URL).then((response) => response.data),
	setHmrcOauth: (payload) =>
		http.post(endpoint.hmrc.SET_HMRC_OAUTH_URL, payload).then((response) => response.data),
	deleteHmrcOauth: () =>
		http.delete(endpoint.hmrc.DELETE_HMRC_OAUTH_URL).then((response) => response.data),
	checkHmrcAvailability: () =>
		http.get(endpoint.hmrc.CHECK_AVAILABILITY).then((response) => response.data),
	getUploadedSalesReports: (payload) =>
		http.post(endpoint.user.UPLOADED_SALES_REPORTS, payload).then((response) => response.data),
	uploadSalesReport: (payload) =>
		http
			.post(endpoint.user.UPLOAD_SALES_REPORT, payload, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((response) => response.data),
	downloadSalesReport: (payload) =>
		http
			.post(endpoint.user.DOWNLOAD_SALES_REPORT(payload.fileId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getSupportedCountryList: () =>
		http.get(endpoint.user.SUPPORTED_COUNTRY_LIST).then((response) => response.data),
	getAllCountries: () => http.get(endpoint.country.ALL).then((response) => response.data),
};
